'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';

import { styles } from './Sidebar.styles';

type Item = {
  title: string;
  url: string;
};

export interface SidebarProps {
  data: Item[];
  className?: string;
  onActiveClick: () => void;
}

const isActive = (url: string, pathname: string) => {
  return url.replaceAll('/', '') === pathname.replaceAll('/', '');
};

export function Sidebar({
  onActiveClick,
  data,
  className,
  ...props
}: SidebarProps) {
  const slots = styles();
  const pathname = usePathname();

  return (
    <div
      className={slots.base({ className })}
      {...props}
    >
      {data.map(({ title, url }, index) => (
        <Link
          className={slots.link({ active: isActive(url, pathname) })}
          href={url}
          key={index}
          onClick={() => {
            if (isActive(url, pathname)) {
              onActiveClick?.();
            }
          }}
        >
          <span>{title}</span>
          <ChevronIcon className={slots.chevronIcon()} />
        </Link>
      ))}
    </div>
  );
}
